<template>
    <div class="relative w-18 h-18">
        <div ref="progressbar" class=" h-full w-full"></div>
        <div class="absolute h-full w-full top-0 text-center mt-6 select-none">
            {{ course_finished }}%
        </div>
    </div>
</template>
<script>
import ProgressBar from "progressbar.js";
export default {
    props: ["course_finished"],
    mounted() {
        this.$refs.progressbar.innerHTML = null;
        var bar = new ProgressBar.Circle(this.$refs.progressbar, {
            strokeWidth: 8,
            easing: "easeInOut",
            duration: 1400,
            color: "#D0A97E",
            trailColor: "#EFEFEF",
            trailWidth: 8,
            svgStyle: null,
        });

        bar.animate(this.course_finished / 100);
    },
    watch: {
        course_finished() {
            this.$refs.progressbar.innerHTML = null;
            var bar = new ProgressBar.Circle(this.$refs.progressbar, {
                strokeWidth: 8,
                easing: "easeInOut",
                duration: 1400,
                color: "#D0A97E",
                trailColor: "#EFEFEF",
                trailWidth: 8,
                svgStyle: null,
            });

            bar.animate(this.course_finished / 100);
        },
    },
};
</script>

<style>
#progress_circle {
    position: relative;
    height: 90px;
    width: 90px;
    transform: rotate(270deg);
    margin-right: 10px;
}
#progress_circle circle {
    height: 100px;
    width: 100px;
    fill: none;
    stroke-width: 7;
    stroke: #000;
    transform: translate(5px, 5px);
    stroke-dasharray: 251;
    stroke-dashoffset: 251;
    stroke-linecap: round;
}
#progress_circle circle:nth-child(2) {
    animation: test 1.3s ease;
}

@keyframes test {
    from {
        stroke-dashoffset: 251;
    }
}
</style>

<style scoped>
#container {
    position: relative;
}
#container #number {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 7px;
}

@media screen and (max-width: 900px) {
    #course:hover {
        transform: none;
    }
}
</style>
